// Stable keys for the document categories that integrations write into.
// Resolve these categories by systemKey, never by display name - the names have drifted before and
// silently broke every upload that depended on them.
export default {
  SupplierInvoices: 'SupplierInvoices',
  SupplierCreditNotes: 'SupplierCreditNotes',
  GeneralOther: 'GeneralOther'
}
